import { cn } from "@/lib/utils";

export interface JJWordmarkProps {
  /** Visual size — controls font-size in rem-equivalents. */
  size?: "sm" | "md" | "lg";
  /** "red" (default) renders in J&J Red; "white" inverts for use on red surfaces. */
  tone?: "red" | "white";
  className?: string;
}

const sizeClasses: Record<NonNullable<JJWordmarkProps["size"]>, string> = {
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-4xl",
};

/**
 * Johnson & Johnson wordmark, rendered in Johnson Display Bold per the
 * brand guidelines (the script-style mark is reserved for official
 * corporate communications and is not redistributed in the brand kit
 * we have access to). For internal POCs this typeset wordmark is the
 * supported pattern.
 */
export function JJWordmark({ size = "md", tone = "red", className }: JJWordmarkProps) {
  return (
    <span
      aria-label="Johnson & Johnson"
      className={cn(
        "font-display font-bold tracking-tight whitespace-nowrap select-none",
        sizeClasses[size],
        tone === "red" ? "text-primary" : "text-white",
        className,
      )}
    >
      Johnson&nbsp;&amp;&nbsp;Johnson
    </span>
  );
}
